import { useState } from "react";
import { faqs } from "@/mocks/chigua";
import SectionHead from "./SectionHead";
import Reveal from "@/components/feature/Reveal";

const trustItems = [
  { icon: 'ri-verified-badge-fill', title: '官方权威', desc: '仅发布经认证的官方消息', tone: 'text-accent-600 bg-accent-100' },
  { icon: 'ri-shield-keyhole-fill', title: '安全加密', desc: '全链路传输与数据加密', tone: 'text-primary-600 bg-primary-100' },
  { icon: 'ri-history-fill', title: '全程留痕', desc: '官方内容可溯源可归档', tone: 'text-secondary-700 bg-secondary-100' },
  { icon: 'ri-customer-service-fill', title: '客服在线', desc: '工作日快速响应解答', tone: 'text-accent-700 bg-accent-100' },
];

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-5">
          {/* 左侧信任区 */}
          <Reveal className="lg:col-span-2">
            <div className="lg:sticky lg:top-28">
              <div className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
                <i className="ri-question-answer-line text-sm"></i>
                帮助与信任
              </div>
              <h2 className="font-heading mt-3 text-2xl font-black text-foreground-950 md:text-4xl">
                常见问题与官方承诺
              </h2>
              <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600 md:text-base">
                关于官方消息渠道、声明区分、防骗与转载使用,这里有最常被问到的问题,一页说清楚。
              </p>

              <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
                {trustItems.map((t) => (
                  <div key={t.title} className="flex items-center gap-3 rounded-xl border border-background-200/70 bg-background-50 p-3.5">
                    <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl text-xl ${t.tone}`}>
                      <i className={t.icon}></i>
                    </span>
                    <div>
                      <div className="text-sm font-bold text-foreground-950">{t.title}</div>
                      <div className="text-xs text-foreground-500">{t.desc}</div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-5 flex items-center gap-3 rounded-2xl bg-gradient-to-r from-accent-500 to-accent-600 p-4 text-background-50">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-background-50/20 text-2xl">
                  <i className="ri-customer-service-2-fill"></i>
                </span>
                <div className="flex-1">
                  <div className="text-sm font-bold">仍有疑问？找官方客服</div>
                  <div className="text-xs text-background-100/90">工作日 9:00 - 21:00 在线解答</div>
                </div>
                <a href="#channels" className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full bg-background-50 px-4 py-2 text-xs font-semibold text-accent-700 transition-colors hover:bg-background-100">
                  去咨询
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </Reveal>

          {/* FAQ 手风琴 */}
          <Reveal className="lg:col-span-3" delay={80}>
            <div className="flex flex-col gap-3">
              {faqs.map((f, i) => {
                const open = openIdx === i;
                return (
                  <div
                    key={f.q}
                    className={`overflow-hidden rounded-2xl border transition-colors ${
                      open ? 'border-primary-200 bg-background-50' : 'border-background-200/70 bg-background-50/70'
                    }`}
                  >
                    <button
                      type="button"
                      onClick={() => setOpenIdx(open ? -1 : i)}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="flex items-start gap-3">
                        <span className={`mt-0.5 font-label text-sm font-bold ${open ? 'text-primary-600' : 'text-foreground-300'}`}>
                          {String(i + 1).padStart(2, '0')}
                        </span>
                        <span className="text-sm font-semibold leading-snug text-foreground-900 md:text-base">{f.q}</span>
                      </span>
                      <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-lg transition-all ${open ? 'rotate-45 bg-primary-500 text-background-50' : 'bg-secondary-100 text-secondary-800'}`}>
                        <i className="ri-add-line"></i>
                      </span>
                    </button>
                    {open && (
                      <div className="px-5 pb-5 pl-[60px]">
                        <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}